import * as React from "react"

const SvgEdit = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 19.714h1.425L16.2 9.94l-1.425-1.425L5 18.29v1.425Zm-1 2a.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713V18.29a1.98 1.98 0 0 1 .575-1.4L16.2 4.29q.3-.275.663-.425.361-.15.762-.15c.401 0 .525.05.775.15q.375.15.65.45l1.375 1.4q.3.275.438.65a2.17 2.17 0 0 1 0 1.513 1.9 1.9 0 0 1-.438.662l-12.6 12.6a1.98 1.98 0 0 1-1.4.575H4ZM15.475 9.24l-.7-.725L16.2 9.94z" />
  </svg>
)
export default SvgEdit
